import styled from "styled-components";

export const Title = styled.h1`
  margin: 0 auto;
  align-items: center;
  font-family: Cormorant Infant;
  font-size: 76px;
  font-weight: 500;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 60px;
  @media (max-width: 430px) {
    font-size: 56px;
    width: 373px;
    padding: 0;
    margin: 0;
  }
`;

export const Block1 = styled.div`
  display: flex;
  background-color: #c7e8e8;
  border-radius: 20px;
  flex-direction: row;
  width: 1300px;
  margin: 0 auto;
  padding-right: 50px;
  padding-left: 50px;
  padding-top: 20px;
  padding-bottom: 20px;
  gap: 100px;
  margin-bottom: 30px;
  @media (max-width: 430px) {
    flex-direction: column;
    width: 373px;
    padding-left: 10px;
    margin: 10px;
  }
`;
export const Block2 = styled.div`
  display: flex;
  background-color: #bcd3ff;
  border-radius: 20px;
  flex-direction: row;
  width: 1300px;
  margin: 0 auto;
  padding-right: 50px;
  padding-left: 50px;
  padding-top: 20px;
  padding-bottom: 20px;
  gap: 100px;
  margin-bottom: 30px;
  @media (max-width: 430px) {
    flex-direction: column;
    width: 373px;
    padding-left: 10px;
    margin: 10px;
  }
`;
export const Block3 = styled.div`
  display: flex;
  background-color: #96cfff;
  border-radius: 20px;
  flex-direction: row;
  width: 1300px;
  margin: 0 auto;
  padding-right: 50px;
  padding-left: 50px;
  padding-top: 20px;
  padding-bottom: 20px;
  gap: 100px;
  margin-bottom: 30px;
  @media (max-width: 430px) {
    flex-direction: column;
    width: 373px;
    padding-left: 10px;
    margin: 10px;
  }
`;
export const Block4 = styled.div`
  display: flex;
  background-color: #55749f;
  border-radius: 20px;
  flex-direction: row;
  width: 1300px;
  margin: 0 auto;
  padding-right: 50px;
  padding-left: 50px;
  padding-top: 20px;
  padding-bottom: 20px;
  gap: 100px;
  margin-bottom: 30px;
  @media (max-width: 430px) {
    flex-direction: column;
    width: 373px;
    padding-left: 10px;
    margin: 10px;
  }
`;
export const BlickTitle = styled.div`
  font-family: Cormorant Infant;
  font-size: 55px;
  font-weight: 500;
  width: 60%;
  @media (max-width: 430px) {
    font-size: 35px;
    width: 363px;
  }
`;
export const BlickTitle4 = styled.div`
  font-family: Cormorant Infant;
  font-size: 55px;
  font-weight: 500;
  width: 60%;
  color: white;
  @media (max-width: 430px) {
    font-size: 35px;
  }
`;
export const BlockTextCont = styled.div`
  display: block;
  width: 90%;
  @media (max-width: 430px) {
    width: 393px;
    font-size: 18px;
  }
`;
export const BlockText = styled.div`
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: left;
  @media (max-width: 430px) {
    width: 353px;
    font-size: 18px;
  }
`;
export const BlockText4 = styled.div`
  font-family: Avenir Next;
  font-size: 25px;
  font-weight: 400;
  text-align: left;
  color: white;
  @media (max-width: 430px) {
    width: 353px;
    font-size: 18px;
  }
`;
export const BtnCont = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  @media (max-width: 430px) {
    gap: 5px;
  }
`;
export const Btn4 = styled.a`
  margin-top: 15px;
  display: flex;
  text-decoration: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 5px 15px;
  min-width: 10px;
  height: 30px;
  background-color: transparent;
  color: white;
  border: 1px solid white;
  cursor: pointer;
  border-radius: 30px;
  font-size: 18px;
  font-family: Avenir Next;
  text-decoration: none;
  font-weight: 500;
  letter-spacing: -0.04em;
  text-align: left;

  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;
export const Btn = styled.a`
  margin-top: 15px;
  display: flex;
  text-decoration: none;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 5px 15px;
  min-width: 10px;
  height: 30px;
  background-color: transparent;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  border-radius: 30px;
  font-size: 18px;
  font-family: Avenir Next;
  text-decoration: none;
  font-weight: 500;
  letter-spacing: -0.04em;
  text-align: left;

  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
    border: 1px solid black;
  }
`;
